package com.milta.core.localization.translations.pl

import com.milta.core.localization.PackageLabelScanStrings

internal val PackageLabelScan = PackageLabelScanStrings(
    scanTitle = "Zeskanuj etykietę",
    analysingTitle = "Odczytywanie etykiety…",
    analysingSubtitle = "Szukamy imienia, adresu i numeru telefonu odbiorcy. To zajmie tylko kilka sekund.",
    reviewTitle = "Potwierdź dostawę",
    deliveryDetectedLabel = "Wykryto dostawę",
    allReadableLabel = "Wszystko czytelne",
    fieldToCompleteSingularSuffix = "pole do uzupełnienia",
    fieldToCompletePluralSuffix = "pola do uzupełnienia",
    recipientNotDetectedValue = "Nie wykryto",
    addressNotDetectedValue = "Nie wykryto",
    phoneNotDetectedValue = "Nie wykryto",
    fieldRequiredWarning = "Pole wymagane do dodania dostawy",
    recipientCorrectionPlaceholder = "Wpisz odbiorcę…",
    addressCorrectionPlaceholder = "Wpisz adres…",
    unreadableTitle = "Etykieta nieczytelna.",
    unreadableMessage = "Zrób nowe zdjęcie skadrowane na etykiecie, dobrze oświetlone i bez odblasków.",
    maxAttemptsMessage = "Uzupełnij tę dostawę ręcznie lub zacznij skanowanie od nowa z nowym zdjęciem.",
)
